// src/features/index.ts
var FEATURE_FLAGS = [];
var FEATURE_RUNGS = ["customer", "org", "tenant", "user"];
var FEATURE_FLAG_NAMES = new Set(FEATURE_FLAGS.map((f) => f.name));
function isKnownFeatureFlag(name) {
  return FEATURE_FLAG_NAMES.has(name);
}
function flagValues(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return {};
  return Object.fromEntries(
    Object.entries(value).filter(
      (entry) => typeof entry[1] === "boolean"
    )
  );
}
function resolveFeatureFlags(valuesByRung, registry = FEATURE_FLAGS) {
  const out = {};
  for (const flag of registry) {
    let enabled = flag.default;
    let source = "default";
    for (const rung of FEATURE_RUNGS) {
      const values = flagValues(valuesByRung[rung]);
      if (flag.name in values) {
        enabled = values[flag.name];
        source = rung;
      }
    }
    out[flag.name] = { name: flag.name, enabled, source };
  }
  return out;
}
function featureFlagLayer(response, registry = FEATURE_FLAGS) {
  const flags = response?.flags ?? {};
  return Object.fromEntries(
    registry.map((flag) => [flag.name, flags[flag.name]?.enabled ?? flag.default])
  );
}

export { FEATURE_FLAGS, FEATURE_FLAG_NAMES, FEATURE_RUNGS, featureFlagLayer, flagValues, isKnownFeatureFlag, resolveFeatureFlags };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map